import { TransformRule, TransformRuleData } from "./TransformRule";

export { ReplaceFirst, ReplaceFirstData };

type ReplaceFirstData = {
  findPattern: string;
  replaceText: string;
} & TransformRuleData;

class ReplaceFirst extends TransformRule {
  findPattern: string;
  replaceText: string;
  constructor(data: ReplaceFirstData) {
    super(data);
    this.findPattern = data.findPattern;
    this.replaceText = data.replaceText;
  }

  getDlfVariables() {
    return super._getDlfVariables(this.replaceText);
  }

  getVariables(): string[] {
    return super._getVariables(this.replaceText);
  }

  isConfigured(): boolean {
    return this.findPattern.length > 0;
  }

  getRuleId(): string {
    return `${this.getDiscriminator()}-${this.fieldName}-${this.position}-${this.replaceText}-${this.findPattern}`;
  }

  toData(): ReplaceFirstData {
    return {
      discriminator: this.discriminator,
      fieldName: this.fieldName,
      position: this.position,
      findPattern: this.findPattern,
      replaceText: this.replaceText,
    };
  }

  static createTest(rest: Partial<ReplaceFirstData> = {}): ReplaceFirst {
    const data: ReplaceFirstData = {
      discriminator: "T_REPFIRST",
      fieldName: "",
      position: 0,
      findPattern: "",
      replaceText: "",
    };

    return new ReplaceFirst({
      ...data,
      ...rest,
    });
  }
}
